import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import PageBanner from '../components/PageBanner';
import Seo from '../components/Seo';
import { PAGE_BANNER_IMAGES } from '../data/homeData';
import '../Home.css';
import '../PageBanner.css';
import '../ProductDetail.css';

function NotFoundPage() {
  return (
    <div className="page">
      <Seo
        title="Page Not Found"
        description="The requested page could not be found."
        path={window.location.pathname}
        noindex
      />
      <Header />
      <main className="main products-page-main">
        <PageBanner
          image={PAGE_BANNER_IMAGES.products}
          eyebrow="404"
          title="Page not found"
          lead="The page may have moved or no longer exists."
          breadcrumbs={[{ label: 'Not found' }]}
        />
        <div className="pd-shell pd-not-found">
          <Link to="/" className="pd-back-link">
            <ArrowLeft size={16} />
            Back to home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default NotFoundPage;
